import type { UserProps } from "../hooks/auth";

/**
 * URL para exibir avatar: prioriza data URL / photoBase64 (como no app),
 * depois photoURL ou avatar HTTP(S).
 */
export function getProfilePhotoSrc(
  user: UserProps | null | undefined
): string | undefined {
  if (!user) return undefined;
  if (user.photoURL?.startsWith("data:image")) return user.photoURL;
  const b = user.photoBase64;
  if (b && typeof b === "string") {
    const t = b.trim();
    if (!t) return undefined;
    if (t.startsWith("data:")) return t;
    return `data:image/jpeg;base64,${t}`;
  }
  if (user.photoURL && /^https?:\/\//i.test(user.photoURL)) {
    return user.photoURL;
  }
  if (user.avatar && /^https?:\/\//i.test(user.avatar)) return user.avatar;
  if (user.avatar?.startsWith("data:")) return user.avatar;
  return undefined;
}

export function getProfileDisplayName(
  user: UserProps | null | undefined
): string {
  if (!user) return "Estudante";

  const candidates = [user.displayName, user.name]
    .map((v) => (typeof v === "string" ? v.trim() : ""))
    .filter(Boolean)
    .filter(
      (v) =>
        v.toLowerCase() !== "usuário" &&
        v.toLowerCase() !== "usuario" &&
        v.toLowerCase() !== "estudante" &&
        !v.includes("@")
    );

  if (candidates.length > 0) return candidates[0];
  return "Estudante";
}
